import { render, staticRenderFns } from "./NavigationSide.html?vue&type=template&id=54a7accd&scoped=true&"
import script from "./NavigationSide.js?vue&type=script&lang=js&"
export * from "./NavigationSide.js?vue&type=script&lang=js&"
import style0 from "./NavigationSide.scss?vue&type=style&index=0&id=54a7accd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7accd",
  null
  
)

export default component.exports